/* global TD, FS, gApiConfig, gRootURL */
import $ from "jquery";
import { runCallbacks as runGlobalCallbacks } from "./td";

var viewInitFns = [];

function isVisible(id) {
	// get bottom line in doc coords
	var b = $(window).scrollTop() + $(window).height();
	var t = $(id).offset().top;
	return t < b;
}

function createLoadDetailRequest(url, name, before, hash, innerCallback) {
	var label = String.format(TD.Res["form.load_detail"], name);
	return createRequest({
		url,
		data: { back: gApiConfig.thisUrl },
		label,
		highlight: null,
		before,
		hash,
		continuator: function () { },
		nomatch: function () { },
		innerCallback
	});
}

function createSearchRequest(id, name, keywords, highlight, before, hash, innerCallback) {
	var label = String.format(TD.Res["searchresults.progress"], name);
	return createRequest({
		url: "searchtable.aspx",
		data: {
			t: id,
			keywords: keywords,
			back: gApiConfig.thisUrl
		},
		label,
		highlight,
		before,
		hash,
		continuator: function () { return TD.Res["searchresults.action.continue"]; },
		nomatch: function () { appendNoMatch(before, name); },
		innerCallback
	});
}

function createSearchAttachmentRequest(keywords, highlight, before) {
	var name = TD.Res["searchresults.attachments"];
	var label = String.format(TD.Res["searchresults.progress"], TD.Res["searchresults.attachments"]);
	return createRequest({
		url: "searchattachments.aspx",
		data: {
			keywords: keywords,
			back: gApiConfig.thisUrl
		},
		label,
		highlight,
		before,
		hash: null,
		continuator: function () { },
		nomatch: function () { appendNoMatch(before, name); },
		innerCallback: null
	});
}

function createRequest({ url, data, label, highlight, before, checkVisible, hash, continuator, nomatch, innerCallback }) {
	checkVisible ||= before;
	return function () {
		var stopLoadMessage = null;
		function continueLoading() {
			function nextCallback() {
				if (innerCallback && isVisible(checkVisible)) {
					// console.log("next is visible on scroll");
					innerCallback();
					innerCallback = null;
				}
			}
			if(innerCallback != null) {
				if(isVisible(checkVisible)) {
					// console.log("next is visible now");
					innerCallback();
				}
				else {
					$(window).on("scroll resize", nextCallback);
				}
			}
			else {
				// console.log("no more callbacks");
				$(window).off("scroll resize", nextCallback);
				$(before).remove();
			}
		}
		function renderTable(data) {
			data = $(data);
			var f = data.filter("form").attr("id");
			data.insertBefore(before);
			runGlobalCallbacks();
			if(f) {
				f = $("#" + f);
				if(hash) {
					$.scrollIntoView("#" + hash);
				}
				$("button.fs-toolaction", f).toolaction({ from: "@data-menu", appendMenuTo: "parent" });
				FS.Form.init(f);
				if(FS.initGrids) {
					var scrollOptions, tab = $("#td-toptab");
					if(tab.length && !FS.mq("screen and (max-height: 640px)"))
						scrollOptions = { top: tab.outerHeight() };
					FS.initGrids(f, !hash, scrollOptions);
				}
				runCallbacks(f);
				if(highlight)
					f.highlight(highlight);
			}
		}
		$(before).css("visibility", "");
		$("span", before).text(label);
		// console.log("get", url);
		$.ajax(url, {
			data: data,
			dataType: "html",
			success: function (data) {
				if(data) {
					renderTable(data);
					// console.log("got data");
					stopLoadMessage = continuator();
				} else {
					nomatch();
				}
			},
			error: function (jqXHR, error, errorThrown) {
				try { console.error(errorThrown || error); } catch(e) { }
				nomatch();
			},
			complete: function () {
				if(!stopLoadMessage || !innerCallback) {
					// console.log("go next view");
					continueLoading();
				}
				else {
					$(before).css("visibility", "hidden");
					$("<button>", { "class": "ui-button small" }).text(stopLoadMessage).on("click", function () {
						$(this).detach();
						continueLoading();
					}).insertBefore(before);
				}
			}
		});
	};
}

function appendNoMatch(after, name) {
	name = $("<div/>").text(name).text();
	var nomatch = $("#td-search-nomatch");
	if(!nomatch.length) {
		$("<div id=\"td-search-nomatch\" class=\"fs-layoutsimple\">").append(
			$("<section class=\"fs-layoutsimple\">").append(
				$("<header>").append(
					$("<h2 class=\"hdr\">").text(TD.Res["searchresults.no_records.title"]),
					$("<div class=\"fs-layoutdesc\">").text(String.format(TD.Res["searchresults.no_records.description"], name))
				)
			)
		).insertAfter(after);
	}
	else {
		$("div.fs-layoutdesc", nomatch).append(", " + name);
	}
}

function reorderTables(tables, qs) {
	var i, hash, m = rgAnchor.exec(location.hash);
	if(m || qs) {
		var tid = m ? m[2] : qs;
		for(i = 0; i < tables.length; i++)
			if(tables[i].id == tid) {
				if(i) tables.unshift(tables.splice(i, 1)[0]);
				if(m) hash = m[1];
				break;
			}
	}
	return hash;
}

function createAsyncActionRequest(url, data, cancelObject, progress, i, l, lastCallback) {
	return function() {
		if(!cancelObject.cancelled) {
			var p = (i / l * 100);
			$("div.ui-progressmeter", progress).css("width", p + "%");
			$("div.ui-progressvalue", progress).text(p.toFixed(0) + "%");
			$("#td-progress-output").text(String.format(TD.Res["action.progress_text"], i, l));
			return $.ajax(url, {
				data: data,
				dataType: "html",
				success: function(data) {
					if(data)
						$(progress).closest("form.fs-form").replaceWith(data);
					else
						lastCallback();
				},
				error: function(jqXHR, error, errorThrown) {
					$(progress).replaceWith($("<div>").text(error + ": " + errorThrown));
				}
			});
		}
	};
}

var rgAnchor = /^#(anchor_([^_]+).*)$/;

function addCallback(fn) {
	viewInitFns.push(fn);
}

function runCallbacks(ctx) {
	for(var i = 0; i < viewInitFns.length; i++)
		viewInitFns[i](ctx);
}

function loadDetailsAsTabs(data) {

	function tabClick(a) {
		var li = a.parent("li");
		var tab = li.closest("ul.ui-tabs");
		var nav = tab.parent();
		var tabid = a.attr("href").replace(/^#anchor_/, "#tab_");
		$("li.active", nav).removeClass("active");
		// var oldA = oldLI.children("a");
		// oldA.css({ "background-color": oldA.data("inactive-color") });
		// var color = a.data("active-color");
		// a.css({ "background-color": color });
		li.addClass("active");
		tab.css("border-bottom-color", li.css("background-color"));
		tab.tabControl("refresh");

		nav.siblings("div").hide();
		$(tabid).show();
		var callback = a.data("callback");
		if(callback) {
			callback();
			a.data("callback", null);
		}
	}

	function onClickTab(e) {
		/* jshint validthis: true */
		var w = $(window), x = w.scrollLeft(), y = w.scrollTop();
		location.hash = $(this).attr("href");
		window.scrollTo(x, y);
		e.preventDefault();
	}

	var tables = data.tables;
	var before = data.before;
	if(tables.length) {
		var m = rgAnchor.exec(location.hash), hash = m && m[1], tid = m && m[2];
		var outer = $("<div/>");
		var nav = $("<nav>", { id: "td-detailtabs" }).appendTo(outer);
		var ul = $("<ul>", { "class": "ui-tabs ui-hollow" }).appendTo(nav);
		var activeTabLink = null;
		for(var i = tables.length - 1; i >= 0; i--) {
			var tt = tables[i];
			var tabid = "#tab_" + tt.id;
			var tabbefore = tabid + "_before";
			var callback = createLoadDetailRequest(tt.url, tt.name, tabbefore, hash, null);
			var active = activeTabLink == null && (i === 0 || tt.id == tid);
			var a = $("<a>", { href: "#anchor_" + tt.id })
					.text(tt.name)
					.data("callback", callback)
					.css("color", tt.color)
					.on("click", onClickTab);

			if(tt.icon != "") {
				a.addClass("ui-icon-custom");
				a.attr("data-icon", tt.icon);
				if(tt.iconOnly) {
					a.addClass("ui-icon-only");
					a.empty().append($("<span class=\"ui-icontext\">").text(tt.name));
				}
			}

			var li = $("<li>").css("background-color", tt.color);
			if(active) {
				activeTabLink = a;
				li.addClass("active");
			}
			ul.prepend(li.append(a));

			outer.append(
				$("<div>", { id: tabid.substring(1), "class": "td-detailtab" })
				.toggle(active)
				.append(
					$("<p>", { id: tabbefore.substring(1) })
					.text(String.format(TD.Res["form.load_detail"], tables[i].name))
					.prepend("<img align=\"absmiddle\" src=\"" + gRootURL + "/img/wait.gif\">"))
				);
		}
		$(before).replaceWith(outer.children());
		ul.tabControl({ useOneRow: true });
		nav.on("click", "li:not(.ui-tab-chevron)>a", function() { tabClick($(this)); });
		// simulate click to start loading

		tabClick(activeTabLink);
	}
	else {
		$(before).remove();
	}
}

function loadDetailsAsList(data) {
	var tables = data.tables;
	var before = data.before;
	if(tables.length) {
		var lastCallback = null;
		var hash = reorderTables(tables);
		for(var i = tables.length - 1; i >= 0; i--)
			lastCallback = createLoadDetailRequest(tables[i].url, tables[i].name, before, i === 0 ? hash : null, lastCallback);
		lastCallback();
	}
	else {
		$(before).remove();
	}
}

function loadDetails(data) {
	return data.tabs ? this.loadDetailsAsTabs(data) : this.loadDetailsAsList(data);
}

function searchAll(data) {
	var tables = data.tables;
	var before = data.before;
	if(tables.length) {
		var keywords = data.keywords;
		var highlight = data.highlight;
		var hash = reorderTables(tables, $.qstring().get("t"));

		var lastCallback = data.attachments ? createSearchAttachmentRequest(keywords, highlight, before) : null;
		for(var i = tables.length - 1; i >= 0; i--) {
			lastCallback = createSearchRequest(tables[i].id, tables[i].name, keywords, highlight, before, i === 0 ? hash : null, lastCallback);
		}
		if(lastCallback != null)
			lastCallback();
	}
	else {
		$(before).remove();
	}
}

function asyncAction(data) {
	var returnURL = $.qstring().get("ReturnUrl") || gApiConfig.backUrl;
	var cancelObject = {};
	function back() {
		cancelObject.cancelled = true;
		$("button", progress).prop("disabled", true);
		$("#td-progress-output", progress).text("");
		if(returnURL) {
			var m = /[?#]/.exec(returnURL);
			var hostAndPath = returnURL.substring(0, m ? m.index : returnURL.length);
			if(hostAndPath.indexOf(':') < 0 || /^https?:/i.test(hostAndPath)) {
				location.replace(returnURL);
			}
		}
	}
	var progress = data.progress;
	$("button", progress).on("click", back);
	var lastCallback = back;
	var ids = data.ids, l = ids.length;
	for(var i = l - 1; i >= 0; i--) {
		lastCallback = createAsyncActionRequest(data.url, { ids: ids[i] }, cancelObject, progress, i + 1, l, lastCallback);
	}
	lastCallback();
}

function loadDashboard() {
	var rows = $(".js-dashboardasync").get();
	if (rows.length) {
		var checkVisible = null;
		var callback = null;
		for (var i = rows.length - 1; i >= 0; i--) {
			var row = rows[i];
			var views = $(".js-dashboardviewasync", row).get();
			if (views.length) {
				var rowCheckVisible = checkVisible;
				for (var j = views.length - 1; j >= 0; j--) {
					var view = views[j];
					var before = $(view);
					var createContinuator = (before) => () => { before.remove(); };
					callback = createRequest({
						url: view.dataset.url,
						data: { back: gApiConfig.thisUrl },
						label: "",
						highlight: null,
						before,
						checkVisible: rowCheckVisible || row,
						hash: null,
						continuator: createContinuator(before),
						nomatch: function () { },
						innerCallback: callback
					});
					rowCheckVisible = null;
				}
				// load
				checkVisible = row;
			}
		}
		if (callback) {
			callback();
		}
	}
}

export { addCallback, runCallbacks, loadDetailsAsTabs, loadDetailsAsList, loadDetails, searchAll, asyncAction, loadDashboard };
